import { Breadcrumb, BreadcrumbItem, BreadcrumbSkeleton, SkeletonText } from "@carbon/react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const PageTitleBlock = ({
  title,
  subtitle,
  icon,
  breadcrumbs,
  infoBits,
  loading
}) => {
  const createBreadcrumbs = itemList => (
    <Breadcrumb>
      {itemList.map((d, i) => (
        <BreadcrumbItem key={`breadcrumb-${i}`}>
          <Link to={d.url} state={d.state !== null ? d.state : {}}>{d.label}</Link>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );

  const createInfoBits = itemList => (
    <div className="cds--col-lg-8 cds--col-md-8 page-title-block__info">
      <div>
        {itemList.map((d, i) =>
          d.value !== -1 ? (
            <div className="page-title-block__infoBit" key={`infoBit-${i}`}>
              <h5>
                {d.icon}
                {d.label}
              </h5>
              <p>{d.value}</p>
            </div>
          ) : null
        )}
      </div>
    </div>
  );

  const breadcrumbList =
    breadcrumbs.length > 0 ? createBreadcrumbs(breadcrumbs) : null;
  const iconObject =
    icon !== null ? <div className="page-title-block__icon">{icon}</div> : null;
  const subtitleObject = subtitle !== "" ? <p>{subtitle}</p> : null;
  const infoBitList = infoBits.length > 0 ? createInfoBits(infoBits) : null;

  return (
    <>
      <div className="cds--grid page-title-block__breadcrumb_container">
        <div className="cds--row">
          <div className="cds--col">
            {loading ? <BreadcrumbSkeleton /> : breadcrumbList}
          </div>
        </div>
      </div>

      <section className="cds--grid page-title-block__heading_block">
        <div className="cds--row">
          <div className="cds--col-lg-8 cds--col-md-8 page-title-block__title">
            {iconObject}
            <div className="page-title-block__name">
              <div>
                {loading ? (
                  <SkeletonText heading paragraph />
                ) : (
                  <>
                    <h1>{title}</h1>
                    {subtitleObject}
                  </>
                )}
              </div>
            </div>
          </div>
          {loading ? null : infoBitList}
        </div>
      </section>
    </>
  );
};

PageTitleBlock.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.objectOf(PropTypes.any),
  breadcrumbs: PropTypes.arrayOf(PropTypes.object),
  infoBits: PropTypes.arrayOf(PropTypes.any),
  loading: PropTypes.bool
};

PageTitleBlock.defaultProps = {
  title: "",
  subtitle: "",
  icon: null,
  breadcrumbs: [],
  infoBits: [],
  loading: false
};

export default PageTitleBlock;
